import { Bell } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useConsent } from '../lib/consent';
import { APP_VERSION } from '../version';

export default function Footer() {
  const { reopen } = useConsent();

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2 text-blue-600 font-semibold">
            <Bell className="w-5 h-5" />
            <span>RemindMeOf</span>
          </div>
          <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm text-gray-500">
            <Link to="/" className="hover:text-blue-600 transition-colors">Home</Link>
            <Link to="/blog" className="hover:text-blue-600 transition-colors">Tips & Guides</Link>
            <Link to="/about" className="hover:text-blue-600 transition-colors">About Us</Link>
            <Link to="/contact" className="hover:text-blue-600 transition-colors">Contact</Link>
            <Link to="/privacy" className="hover:text-blue-600 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-blue-600 transition-colors">Terms & Conditions</Link>
            <button onClick={reopen} className="hover:text-blue-600 transition-colors">Cookie Preferences</button>
            <Link to="/login" className="hover:text-blue-600 transition-colors">Sign In</Link>
            <Link to="/register" className="hover:text-blue-600 transition-colors">Register</Link>
          </div>
          <div className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} VarBiz Ltd &mdash; v{APP_VERSION}
          </div>
        </div>
      </div>
    </footer>
  );
}
